<template>
  <div v-if="object">
    <div class="row text-white" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>{{'Дата выдачи: ' + convertDate(item.object.date)}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <base-input label="Дата выдачи"
                    v-model="object.date"
                    :value="object.date"
                    :date="true"
        ></base-input>
      </div>
      <div class="col-md-6">
        <base-input label="Срок действия до"
                    v-model="object.untilDate"
                    :value="object.untilDate"
                    :date="true"
        ></base-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <base-input label="Серия"
                    v-model="object.series"
                    :placeholder="object.series">
        </base-input>
      </div>
      <div class="col-md-4">
        <base-input label="Номер"
                    v-model="object.number"
                    :placeholder="object.number">
        </base-input>
      </div>
      <div class="col-md-4">
        <base-input label="Кем выдан"
                    v-model="object.gaveBy"
                    :placeholder="object.gaveBy">
        </base-input>
      </div>
    </div>

  </div>
</template>
<script>

 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       socket: null,
       object: null,
       inSave: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
       this.inSave = true;
       try {
         let renewed = await this.$repo.save(this.object, this.type);
         if (renewed) {
           this.item.object = renewed;
           this.item.id = renewed.id;
           this.object = JSON.parse(JSON.stringify(renewed));
           this.inSave = false;
           this.toView();
         }
       } catch(error) {
         this.inSave = false;
       }
     }
   },
   mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
   }
 }
</script>
